import { useEffect, useState } from 'react';
import {
  getEmailDomainRowIndicator,
  subscribeEmailDomainHealthCache,
  type EmailDomainRowIndicator,
} from '@/lib/emailDomainHealthCache';

export function useEmailDomainRowIndicator(
  email: string | null | undefined
): EmailDomainRowIndicator {
  const [, bump] = useState(0);

  useEffect(() => {
    return subscribeEmailDomainHealthCache(() => bump((n) => n + 1));
  }, []);

  return getEmailDomainRowIndicator(email);
}
